import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  email,
  required,
  TextInput,
  SelectInput,
  maxLength,
  regex,
} from "react-admin";
import Divider from "@material-ui/core/Divider";
import { RightsRow, StaffUserRole } from "../../types/staffUser";
import StaffRoles from "../../helpers/UsersStaffRole";
import "./index.css";
interface Props {
  isUserBlocked: boolean;
  disableInputs?: boolean;
  staffUserRights: Array<RightsRow>;
  setRights: (rights: Array<RightsRow>) => void;
  handleChangeUserStatus: () => void;
  creationDate?: string;
  userRole?: string;
  doesCreate?: boolean;
}
const RoleOptions = [
  { id: StaffUserRole.SuperAdmin, name: "Super Administrator" },
  { id: StaffUserRole.Admin, name: "Administartor" },
  { id: StaffUserRole.Moderatore, name: "Moderator" },
];

const CreateNewStaffUserFormBody = ({
  staffUserRights,
  isUserBlocked,
  userRole,
  setRights,
  handleChangeUserStatus,
  disableInputs,
  creationDate,
  doesCreate,
}: Props) => {
  const [defaultRights, setDefaultRights] = React.useState<boolean>(
    JSON.stringify(staffUserRights) ===
      JSON.stringify(StaffRoles.AdministartorRights) ||
      JSON.stringify(staffUserRights) ===
        JSON.stringify(StaffRoles.ModeratorRights) ||
      JSON.stringify(staffUserRights) ===
        JSON.stringify(StaffRoles.SuperAdministartorRights) ||
      doesCreate
      ? true
      : false
  );
  const [role, setRole] = useState(userRole ? userRole : RoleOptions[1].id);

  const validateMaxLenght = [
    maxLength(50, "Limited to 50 characters inclusive"),
  ];
  
  const validateEmailRequired = [regex(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*\.\w{2,10}$/, "invalid email"), required()];

  const handleRoleChange = (e) => {
    const role = RoleOptions.find((item) => item.id === e.target.value);
    setRole(role!.id);
  };

  useEffect(() => {
    if (defaultRights && role) {
      switch (role) {
        case StaffUserRole.SuperAdmin:
          const newSuperAdmin = [...StaffRoles.SuperAdministartorRights];
          setRights(newSuperAdmin);
          break;
        case StaffUserRole.Admin:
          const newArrAdmin = [...StaffRoles.AdministartorRights];
          setRights(newArrAdmin);
          break;
        case StaffUserRole.Moderatore:
          const newArr = [...StaffRoles.ModeratorRights];
          setRights(newArr);
          break;
        default:
          break;
      }
    }
  }, [role, defaultRights]);

  const hadnleChangeRightsCheckboxes = (row: number, checkboxLabel: string) => {
    setDefaultRights(false);
    const oldArrayCopy = [...staffUserRights];
    const newArr = [
      ...oldArrayCopy.slice(0, row),
      {
        ...oldArrayCopy[row],
        rights: {
          ...oldArrayCopy[row].rights,
          [checkboxLabel]: !oldArrayCopy[row].rights[checkboxLabel],
        },
      },
      ...oldArrayCopy.slice(row + 1),
    ];
    setRights([...newArr]);
  };

  return (
    <Box id="staffUserForm">
      <Box className="staffUserForm_personalDetailsWrapper">
        <Typography variant="h6">Personal Details</Typography>
        <Divider />
        <Box className="detailsFieldsWrapper">
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Typography gutterBottom className="base-color">
              First Name
            </Typography>
            <TextInput
              source="name"
              disabled={disableInputs}
              fullWidth
              className="createStaffInputField"
              label=""
              validate={validateMaxLenght}
            />
          </Box>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Typography gutterBottom className="base-color">
              Last Name
            </Typography>
            <TextInput
              source="surname"
              disabled={disableInputs}
              fullWidth
              className="createStaffInputField"
              label=""
              validate={validateMaxLenght}
            />
          </Box>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Typography className="base-color">Email address</Typography>
            <TextInput
              source="email"
              disabled={disableInputs}
              fullWidth
              className="createStaffInputField"
              label=""
              validate={validateEmailRequired}
            />
          </Box>
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Typography className="base-color">Skype</Typography>
            <TextInput
              source="skype"
              disabled={disableInputs}
              fullWidth
              className="createStaffInputField"
              label=""
            />
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography variant="h6">Role Details</Typography>
        <Divider variant="fullWidth" />
        <Box className="detailsFieldsWrapper">
          <Box
            marginTop="2rem"
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Typography className="base-color">Start date</Typography>
            <Box style={{ width: 200 }}>
              <TextInput
                source="createDate"
                type="date"
                className="createStaffInputField"
                defaultValue={
                  creationDate
                    ? creationDate
                    : new Date().toISOString().substr(0, 10)
                }
                disabled={disableInputs}
                onChange={(e) => console.log(e.target.value)}
                fullWidth
                label=""
              />
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            marginBottom="1.5em"
          >
            <Typography className="base-color">Role</Typography>
            <Box style={{ width: 200 }}>
              {role && (
                <SelectInput
                  source="role"
                  label=""
                  disabled={disableInputs}
                  fullWidth
                  variant="outlined"
                  value={role}
                  className="selectInput"
                  onChange={handleRoleChange}
                  choices={RoleOptions}
                />
              )}
            </Box>
            <Box paddingTop=".3em" alignItems="center" display="flex">
              <Checkbox
                checked={defaultRights}
                disabled={disableInputs}
                onChange={() =>
                  setDefaultRights((defaultRights) => !defaultRights)
                }
                color="primary"
              />
              <Typography className="base-color">
                Use default User rights
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            width="50%"
            marginBottom="2em"
          >
            <Typography className="base-color">Status</Typography>
            <label className="switch checkbox-margin">
              <input
                type="checkbox"
                disabled={disableInputs}
                onChange={handleChangeUserStatus}
                checked={!isUserBlocked}
              />
              <span className="slider round"></span>
            </label>
          </Box>
          <Box>
            <TableContainer component={Card}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Pages</TableCell>
                    <TableCell scope="row" align="center">
                      View
                    </TableCell>
                    <TableCell scope="row" align="center">
                      Update
                    </TableCell>
                    <TableCell scope="row" align="center">
                      Delete
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="staffUserPermisionsTable">
                  {staffUserRights &&
                    staffUserRights.map((row, i) => {
                      return (
                        <>
                          <TableRow key={`${row.page}${i}`}>
                            <TableCell component="th" scope="row">
                              <p
                                className={
                                  row.page === "Statistic" ||
                                  row.page === "Dream home" ||
                                  row.page === "Lifestyle Prizes" ||
                                  row.page === "Fixed Odds" ||
                                  row.page === "General" ||
                                  row.page === "Winners" ||
                                  row.page === "Referrals" ||
                                  row.page === "Reports"
                                    ? "titleSubCategory"
                                    : ""
                                }
                              >
                                {row.page}
                              </p>
                            </TableCell>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                disabled={disableInputs}
                                checked={row.rights["View"]}
                                onChange={() =>
                                  hadnleChangeRightsCheckboxes(i, "View")
                                }
                                className="input-form"
                              />
                            </TableCell>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                disabled={disableInputs}
                                checked={row.rights["Update"]}
                                onChange={() =>
                                  hadnleChangeRightsCheckboxes(i, "Update")
                                }
                                className="input-form"
                              />
                            </TableCell>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                disabled={disableInputs}
                                checked={row.rights["Delete"]}
                                onChange={() =>
                                  hadnleChangeRightsCheckboxes(i, "Delete")
                                }
                                className="input-form"
                              />
                            </TableCell>
                          </TableRow>
                          {row.page === "Competitions" ||
                          row.page === "Staff management" ? (
                            <TableRow className="titleRow">
                              <TableCell>
                                {row.page === "Competitions" ? (
                                  <p>Prize management</p>
                                ) : null}
                                {row.page === "Staff management" ? (
                                  <p>Settings</p>
                                ) : null}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : null}
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default CreateNewStaffUserFormBody;
